import React, { useState, useEffect } from "react";
import { useLanguage } from "../../hooks/useLanguage";
import { COMPANY_INTRO_URL } from "../../utils/urls";
import instance from "../../services/services";


function CompanyIntro(){
  const { t } = useLanguage();
  const [companyIntro, setCompanyIntro] = useState([]);

  useEffect(() => {
    const fetchTitleList = async () => {
        try {
            const response = await instance.post(COMPANY_INTRO_URL);
            setCompanyIntro(response.data.data);
        } catch (error) {
            console.error('회사 소개 데이터 가져오기 실패', error);
        }
    };
    fetchTitleList();
}, []);

  return(
    <section className="about_container">
      <h3 className="commu_title noline">{t('about_us')}</h3>
      
      {companyIntro.map((item, index) => (
        <article className="article1" key={index}>
          <div className="intro_title">
            <span>{item.title1}</span>
            <span>{item.title2}</span>
            <span>{item.title3}</span>
          </div>
          <p>
            {item.contents}
          </p>
          <div className="article2">
            <img src={item.file_path} alt="intro" loading="lazy"/>
          </div>
        </article>
      ))}

    </section>
  )
};

export default CompanyIntro;
